import { showAlert } from "store/slices/alertSlice";

const handleApiResponse = ({
  actionResult,
  dispatch,
  onSuccess = () => {},
  onFailure = () => {},
}) => {
  const { statusCode, success, message ,data } = actionResult?.payload || {};
  if (statusCode === 200 && success) {
    dispatch(showAlert({ text: message, type: "success" }));
    onSuccess(data);
  } else {
    dispatch(
      showAlert({ text: message || "Something went wrong", type: "error" })
    );
    onFailure();
  }
};

const apiThenCatch = ({ promise, dispatch, onSuccess, onFailure }) => {
  promise
    .then((res) => {
      handleApiResponse({
        actionResult: res,
        dispatch,
        onSuccess,
        onFailure,
      });
    })
    .catch(() => {
      dispatch(showAlert({ text: "Something went wrong", type: "error" }));
      onFailure?.();
    });
};

// SUBMIT FORM FUNCTION FOR COMMON MODULES
const handleSubmitForm = ({
  dispatch,
  action,
  payload,
  onSuccess = () => {},
  onFailure = () => {},
}) => {
  apiThenCatch({
    promise: dispatch(action(payload)),
    dispatch,
    onSuccess,
    onFailure,
  });
};

// FOR STATUS UPDATE
const handleStatusUpdate = ({
  _id,
  status,
  dispatch,
  action,
  onSuccess = () => {},
  onFailure = () => {},
}) => {
  apiThenCatch({
    promise: dispatch(action({ id: _id, status: status === 1 ? 0 : 1 })),
    dispatch,
    onSuccess,
    onFailure,
  });
};

// FOR DELETE
const handleDeleteItem = ({
  id,
  dispatch,
  action,
  onSuccess = () => {},
  onFailure = () => {},
}) => {
  apiThenCatch({
    promise: dispatch(action({ id, status: 2 })),
    dispatch,
    onSuccess,
    onFailure,
  });
};

const appendFormData = (formData, key, value) => {
  // Only skip undefined values, allow null to pass through
  if (value === undefined) return;

  // Handle null explicitly - send as empty string
  if (value === null) {
    formData.append(key, "");
    return;
  }

  if (Array.isArray(value)) {
    value.forEach((item, index) => {
      appendFormData(formData, `${key}[${index}]`, item);
    });
  } else if (typeof value === "object" && !(value instanceof File)) {
    Object.keys(value).forEach((subKey) => {
      appendFormData(formData, `${key}[${subKey}]`, value[subKey]);
    });
  } else {
    formData.append(key, value);
  }
};

export {
  handleSubmitForm,
  handleStatusUpdate,
  handleDeleteItem,
  appendFormData,
};
